
import React from "react";
import { connect } from "react-redux";

import history from "../../auth/history";
import './Subtransaction.css';


class OrderDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone
		}
    }

	


    componentDidMount(){
    }
	componentWillUnmount(){
    }




    render(){
        console.log("order details..."+this.props.response);

    return(
                          
        <div class="col-12 col-sm-6">
        <div class="orderdetail">
            <div class="txnhead">Order Details</div>


            
                                        <div class="odramt">
                                           
												<p>Order Amount <span>₹   {
                                                this.props.amount}</span></p>
												<p>Surcharge <span>₹   {
                                                this.props.surcharge}</span></p>
											</div>
											<div class="ttlamt">
												<p>Total Amount <span>₹ { this.props.totalAmount}</span></p>
						                    </div>   
                                       
            </div>
    </div>

);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone}
	,responseReduce:{moneyTransferResponseDetails}}
	) => ({
		errorMessage,loginErrorMessage,phone,moneyTransferResponseDetails 
});

export default connect(mapStateToProps, null)(OrderDetails);